<template>
    <div :class="['file-upload-box', previewUrl ? 'edit' : '']">
        <div class="preview" v-loading="loading">
            <el-image :src="previewUrl" fit="contain" :preview-src-list="[previewUrl]">
                <div slot="error" class="image-slot">
                    <i class="icon-image-error"></i>
                </div>
            </el-image>
            <div v-if="fileType !== 'image'" class="file-link" @click="goFileLink"></div>
        </div>
        <div class="upload">
            <el-upload ref="fileUpload" :disabled="disabled || loading" action :accept="accept"
                :http-request="uploadFileAction" :show-file-list="false" :before-upload="beforeUploadHandle">
                <span class="icon"></span>
            </el-upload>
        </div>
        <div class="describe">
            <slot name="tips"></slot>
        </div>
    </div>
</template>

<script>
import { uploadFile } from '@/api/file';
import pdf from '@/assets/img/upload/pdf.svg';
import excel from '@/assets/img/upload/excel.svg';
export default {
    props: {
        accept: { //允许上传格式
            type: String,
            default: '',
        },
        value: { // 值
            type: String,
            default: ''
        },
        disabled: {// 禁用
            type: Boolean,
            default: false
        },
        size: {// 上传大小
            type: Array,
            default: () => [0, 10]
        }
    },
    data() {
        return {
            previewUrl: '',
            fileName: '',
            fileType: 'image', // 文件类型支持，image | pdf | xls
            fileLink: '',
            loading: false
        };
    },
    computed: {
        fileBase() {
            const { config } = this.$store.state;
            return config && config.fileUrl
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {
                if (value && this.previewUrl == '') {
                    const name = value.split('/').pop() || '';
                    this.setFile(name, `${this.fileBase}${value}`);
                }
            }
        }
    },
    methods: {
        setFile(fileName, urlfull) {
            if (/\.(xlsx|xls)$/i.test(fileName)) {
                this.previewUrl = excel;
                this.fileType = 'xls'
                this.fileLink = urlfull;
            } else if (/\.pdf$/i.test(fileName)) {
                this.previewUrl = pdf;
                this.fileType = 'pdf'
                this.fileLink = urlfull;
            } else {
                this.previewUrl = urlfull;
                this.fileType = 'image'
            }
        },
        goFileLink() {
            window.open(this.fileLink);
        },
        beforeUploadHandle(file) {
            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async (resolve, reject) => {
                const { accept, size } = this;
                // 验证格式
                const acceptStrs = accept.split(',') || [];
                const acceptMap = acceptStrs.map(s => s.trim());
                const isAccept = acceptMap.find((v) => v == file.type) ? true : false;
                if (!isAccept) {
                    this.$message.error(`文件格式错误,请重新上传`);
                    return reject();
                }

                // 验证大小
                const fileSize = file.size / 1024 / 1024;
                const isSize = fileSize >= size[0] && fileSize <= size[1] ? true : false;
                if (!isSize) {
                    this.$message.error(`文件不能大于${size[1]}M,请重新上传`);
                    return reject();
                }
                resolve()
            })

        },
        async uploadFileAction(file) {
            this.loading = true;
            const formData = new FormData();
            formData.append('file', file.file);

            const response = await uploadFile(formData);
            const { state, result, msg } = response.data;
            this.loading = false;
            if (!state) return this.$message.error(msg || '');
            const { fileName, url, urlfull } = result;
            this.setFile(fileName, urlfull);
            this.$emit('input', url);
            this.$emit('onSuccess', result);
        }
    },
};
</script>

<style lang="scss">
.file-upload-box {
    .preview {
        width: 200px;
        height: 200px;
        position: relative;
        border-radius: 4px;
        overflow: hidden;
        background: url('~@/assets/img/upload/bg.png') no-repeat center;
        background-size: cover;

        .el-image {
            width: 100%;
            height: 100%;

            .image-slot {
                display: none;
            }
        }

        .el-loading-mask {
            background-color: rgba(0, 0, 0, 0.8);

            .el-loading-spinner {
                margin-top: -40px;

                &::after {
                    content: "拼命上传中";
                    color: #fff;
                    display: block;
                    line-height: 20px;
                }

                .path {
                    stroke: #fff;
                }
            }
        }

        .file-link {
            position: absolute;
            z-index: 1;
            width: 100%;
            height: 100%;
            top: 0px;
            left: 0px;
            cursor: pointer;
        }
    }

    .upload {
        position: relative;
        line-height: 0px;
        height: 0px;
        z-index: 9;

        .icon {
            background: url('~@/assets/img/upload/add.svg') no-repeat center;
            background-size: cover;
            content: "";
            width: 30px;
            height: 30px;
            position: absolute;
            bottom: 0px;
            left: 170px;
        }
    }

    .describe {
        line-height: 24px;
        margin-top: 10px;
        font-size: 12px;
        color: $-text-500;
    }

    &.edit {
        .upload .icon {
            background: url('~@/assets/img/upload/edit.svg') no-repeat center;
        }
    }
}
</style>
